import { ReactNode } from 'react';

import { QuestionSetContent } from '@/components/organisms/Dialogs/Action/QuestionSet/QuestionSet';
import { cn } from '@/lib/utils';
import { useQuestionSet } from '@/modules/tryIt/hooks/useQuestionSet';
import { ResponseMessage } from '@/shared/types/tryIt';

import { responseClasses } from './constants';

type QuestionSetMessage = Extract<ResponseMessage, { type: 'question_set' }>;

type QuestionSetResponseProps = {
  response: QuestionSetMessage;
  icon: ReactNode;
  turnRow?: boolean;
};

/** Read-only: Try It is not the web widget, so the set cannot be answered here. */
export const QuestionSetResponse = ({
  response,
  icon,
  turnRow = false,
}: QuestionSetResponseProps) => {
  const fromNode = useQuestionSet(response.action_id);
  const questionSet = response.question_set ??
    fromNode ?? { title: response.name ?? '', questions: [] };

  return (
    <div className={cn(!turnRow && responseClasses)}>
      {!turnRow && icon}
      <div
        className={cn(
          'flex flex-col overflow-hidden rounded-xl bg-background shadow-sm',
          turnRow ? 'max-w-xs shrink-0 self-stretch border border-border px-3 py-4' : 'max-w-sm p-4'
        )}
      >
        <QuestionSetContent questionSet={questionSet} />
      </div>
    </div>
  );
};
